import { gql } from "gql";

export const READ_NOTIFICATION = gql(`
  mutation ReadNotification ($ids:[ID!]!) {
    readNotifications (ids: $ids)
  }
`);
